import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
    selector: 'app-e-ledger',
    templateUrl: './e-ledger.component.html',
    styleUrls: ['./e-ledger.component.css'],
    standalone: false
})
export class ELedgerComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit(): void {


  }

  onBacktoMainPage() {
    this.router.navigate(["/landing-page"]);
  }

}
